import { UploadAssetFieldMui } from '@app/modules/assets/screens/upload/components/UploadAssetFieldMui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

/** Quick-export thumbnail upload for Rudo (maps to config.thumbnailUrl). */
export function RudoQuickExportSettings({ fieldPrefix }: { fieldPrefix?: string }) {
  const { $t } = useIntl();
  return (
    <Box>
      <UploadAssetFieldMui
        name={`${fieldPrefix || ''}.config.thumbnailUrl`.replace(/^\./, '')}
        inputProps={{
          label: $t({
            id: 'common.loadThumbnail',
            defaultMessage: 'Cargar thumbnail',
          }),
          size: 'sm',
          accept: 'image/*',
          maxSizeMb: 2,
          displayMode: 'chip',
        }}
      />
    </Box>
  );
}
